import React, {useContext} from 'react';
import {CSSTransition, TransitionGroup} from 'react-transition-group';
import {Outlet, useLocation} from 'react-router-dom';
import {AppSuspense} from '../../index';
import Scrollbar from '../Scrollbar';
import AppContext from '../../utility/AppContext';
import AppFooter from '../AppLayout/AppFooter';
import Box from '@mui/material/Box';
import {RouteTransition} from '../../../shared/constants/AppEnums';
import AppErrorBoundary from '../AppErrorBoundary';
import AppContextPropsType from '../../../types/AppContextPropsType';
import makeStyles from '@mui/styles/makeStyles';
import {Theme} from '@mui/material';
import {useSelector} from 'react-redux';
import {selectCurrentUser} from '../../../redux/auth/Selectors';

interface TransitionWrapperProps {
  children: any;
}

const useStyle = makeStyles((theme: Theme) => ({
  contentScroll: {
    [theme.breakpoints.up('sm')]: {
    },
    [theme.breakpoints.up('lg')]: {
    },
  }
}));

const TransitionWrapper: React.FC<TransitionWrapperProps> = ({children}) => {
  const {rtAnim} = useContext<AppContextPropsType>(AppContext);
  const location = useLocation();
  if (rtAnim === RouteTransition.NONE) {
    return <>{children}</>;
  }
  return (
    <TransitionGroup appear enter exit>
      <CSSTransition
        key={location.key}
        timeout={{enter: 300, exit: 300}}
        classNames={rtAnim}>
        {children}
      </CSSTransition>
    </TransitionGroup>
  );
};

const ContentView = () => {
  const user = useSelector(selectCurrentUser);

  const classes = useStyle();
  return (
    <Scrollbar className={classes.contentScroll}>
      <Box
        display='flex'
        flex={1}
        mt={4}
        ml={4}
        mr={4}
        flexDirection='column'
        className='main-content-view'>
        <AppSuspense>
          <AppErrorBoundary>
            <TransitionWrapper><Outlet /></TransitionWrapper>
          </AppErrorBoundary>
        </AppSuspense>
      </Box>
      <AppFooter />
    </Scrollbar>
  );
};

export default ContentView;
